// Gantt geometry — continuous-zoom canvas.
// All "absMin" values are minutes from today 00:00.
import { LOGICAL_WINDOW_MIN } from './ganttConfig';

export interface Geom {
  anchor: number;   // minutes from today 00:00 at the left edge (fixed at 0)
  window: number;   // total content span in minutes
  hourPx: number;   // horizontal scale (px per hour) — the zoom level
  hourStep: number; // tick spacing in hours, chosen to keep ticks readable
}

// Tick spacing: smallest step whose on-screen gap is at least ~46px.
function pickHourStep(hourPx: number): number {
  for (const s of [1, 2, 3, 6, 12]) if (s * hourPx >= 46) return s;
  return 24;
}

export function geom(hourPx: number, windowMin: number = LOGICAL_WINDOW_MIN): Geom {
  return { anchor: 0, window: windowMin, hourPx, hourStep: pickHourStep(hourPx) };
}

export const xOf = (absMin: number, g: Geom): number => ((absMin - g.anchor) / 60) * g.hourPx;
export const wOf = (min: number, g: Geom): number => (min / 60) * g.hourPx;
